import PlayMode from "../model/PlayMode";

export default class PlatformParameters {

    constructor(language, interactionState, playMode) {
        this._language = language;
        this._state = interactionState;
        this._playMode = playMode;
    }

    /**
     * @returns {Object} Generic object containing game state (savegame) or null
     */
    get state() {
        return this._state;
    }

    /**
     * @returns {String} Language id
     */
    get language() {
        return this._language;
    }

    /**
     * @returns {PlayMode} Playmode: assessment or demo
     */
    get playMode() {
        return this._playMode;
    }

    /**
     * @param {Object} obj 
     * @returns {PlatformParameters} 
     */
    static fromObject(obj) {
        return new PlatformParameters(
            obj.language,
            JSON.parse(obj.interaction_state),
            PlatformParameters.parsePlayMode(obj.play_mode)
        );
    }

    static parsePlayMode(str) {
        switch (str) {
            case "demo":
                return PlayMode.DEMO;
            case "assessment":
            case null:
            case undefined:
                return PlayMode.ASSESSMENT;
            default:
                throw new Error("Invalid value for play_mode: " + str);
        }
    }
}

